// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Hdlh","alert":"SettungsInbox_alert__1mY9b"};